export default __webpack_public_path__ + "static/media/image.9eeb98a4.png";